<template>
  <v-dialog v-model="dialog" persistent scrollable max-width="600px">
    <v-card>
      <v-card-title primary-title>
        <span class="headline">Edição de empresa</span>
      </v-card-title>
      <v-divider></v-divider>
      <h4 style="margin-top: 20px;margin-left: 15px;">{{this.billingType === 'CREDIT_CARD' ? 'Favor informar os dados do responsável do cartão' : 'Favor preencher os dados abaixo para continuar'}}</h4>
      <v-card-text style="margin-top: 0px;">
        <v-radio-group v-model="value.type_person" row>
          <v-radio label="Pessoa Física" :value="1"></v-radio>
          <v-radio label="Pessoa Jurídica" :value="2"></v-radio>
        </v-radio-group>
        <v-container grid-list-md>
          <v-form ref="form">
            <v-layout row justify-space-between wrap>
              <v-flex xs12 md12>
                <v-text-field v-model="editedItem.id_text" label="Nome*"></v-text-field>
              </v-flex>
              <v-flex xs12 sm6>
                <!-- :rules="fixedSizeRule(editedItem.type_person === 1 ? 'CPF*' : 'CNPJ*', editedItem.type_person === 1 ? 11 : 14, true)" -->
                <v-text-field 
                  :label="editedItem.type_person === 1 ? 'CPF*' : 'CNPJ*'"
                  :rules="editedItem.type_person === 1 ? cpfRule() : cnpjRule()"
                  :mask="editedItem.type_person === 1 ? '###.###.###-##' : '##.###.###/####-##'"
                  v-model="editedItem.cpfcnpj"
                  validate-on-blur
                  :error-messages="field_errors[0].text"
                  :loading="field_errors[0].loading"
                  @blur="existIllisDBRule('cpfcnpj', 0, 'companies')"
                ></v-text-field>
              </v-flex>
              <!-- <v-flex xs12 sm6>
                <v-text-field :rules="requiredRule(editedItem.type_person === '1' ? 'CPF' : 'CNPJ')" v-model="editedItem.cpfcnpj" :mask="editedItem.type_person === '1' ? '###.###.###-##' : '##.###.###/####-##'" :label="editedItem.type_person === '1' ? 'CPF*' : 'CNPJ*'"></v-text-field>
              </v-flex> -->
              <!-- <v-flex xs12 md4>
                <vuetify-google-autocomplete
                  ref="address"
                  id="googleMap"
                  v-model="editedItem.googleMap"
                  append-icon="search"
                  :disabled="false"
                  placeholder="Selecione uma Cidade"
                  label="Cidade"
                  types='(cities)'
                  clearable
                  v-on:blur="controlGoogleAutocomplete"
                  v-on:placechanged="getCityData"
                >
                </vuetify-google-autocomplete>
              </v-flex> -->
              <v-flex xs12 md6>
                <v-text-field :rules="phoneRule('Telefone', 0)" v-model="editedItem.phone" mask="(##) #####-####" label="Telefone*"></v-text-field>
              </v-flex>
              <!-- <v-flex xs12 md12>
                <v-text-field :rules="emailRule('email')" v-model="editedItem.email" label="E-mail*"></v-text-field>
              </v-flex> -->
              <v-flex xs12 md5>
                <v-text-field :rules="requiredRule('Endereço')" v-model="editedItem.address" label="Endereço*"></v-text-field>
              </v-flex>
              <v-flex xs12 md5>
                <v-text-field :rules="requiredRule('Bairro')" v-model="editedItem.neighborhood" label="Bairro*"></v-text-field>
              </v-flex>
              <v-flex xs12 md2>
                <v-text-field :rules="requiredRule('Número')" v-model="editedItem.number" label="Número*"></v-text-field>
              </v-flex>
              <v-flex xs12 md6>
                <v-text-field v-model="editedItem.complement" label="Complemento"></v-text-field>
              </v-flex>
              <v-flex xs12 md6>
                <v-text-field :rules="requiredRule('Cidade')" v-model="editedItem.city" label="Cidade*"></v-text-field>
              </v-flex>
              <v-flex xs12 md6>
                <v-text-field :rules="stateRule('Estado')" v-model="editedItem.state" mask="AA" label="Estado*"></v-text-field>
              </v-flex>
              <v-flex xs12 sm6>
                <v-text-field :rules="fixedSizeRule('CEP', 8)" v-model="editedItem.cep" mask="#####-###" label="CEP*"></v-text-field>
              </v-flex>
            </v-layout>
          </v-form>
        </v-container>
        <small style="color: red;">* Campos obrigatórios</small>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <small>Os dados preenchidos serão usados para nota fiscal</small>
        <v-spacer></v-spacer>
        <v-btn class="mx-2" color="primary darken-2" @click="save">Salvar</v-btn>
        <v-btn class="mx-2" @click="closeDialog">Cancelar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import rules from '../../mixin/rules'

export default {
  name: 'PCompanyUpgrade',
  mixins: [rules],
  props: ['dialog', 'value', 'billingType'],
  data: () => ({
    editedItem: {},
    field_errors: [{ field: 'cpfcnpj', text: '', loading: false }]
  }),
  mounted () {
    this.editedItem = this.value
  },
  methods: {
    closeDialog () {
      this.$emit('dialog', false)
    },
    save () {
      if (this.hasDBRule()) {
        console.log('hasDBRule')
        return false
      }
      if (this.$refs.form && !this.$refs.form.validate()) {
        this.$store.commit('snackbar/change_values', {
          text: 'Por favor, corrija as validações antes de salvar!',
          color: 'warning',
          dialog: true
        })
        return false
      }
      console.log('save')
      this.$emit('save', this.editedItem)
    }
  },
  computed: {
    formValidate () {
      return this.$refs.form.validate()
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/shared/PCompanyUpgrade.vue